angular.module('tradersyard').controller('User.Settings.TimeAndLanguage.Ctrl', [
    '$scope',
    '$cookies',
    'graph-user-factory',
    '$flex',
    '$moment',
    '$timeout',
    function ($scope, $cookies, $client, $flex, $moment, $timeout) {
        angular.extend($scope, {
            status: undefined,
            alert: undefined,
            closeAlert: function () {
                if ($scope.alert) $timeout.cancel($scope.alert);
                $scope.status = undefined;
            },
            updateLocale: function (locale) {
                $client.update('me', { locale: locale }).then(function (response) {
                    if (response.data.state === 0) {
                        $moment.language(locale);

                        $cookies.put('__gpuln', locale);

                        $scope.status = 'Language was updated';
                    } else {
                        $scope.status = 'Something went wrong...';
                    }
                    $scope.alert = $timeout(function () {
                        $scope.status = undefined;
                    }, 10000);
                });
            },
            updateTimezone: function (timezone) {
                $client.update('me', { timezone: timezone }).then(function (response) {
                    if (response.data.state === 0) {
                        $moment.timezone(timezone);

                        $cookies.put('__gputz', timezone);

                        $scope.status = 'Timezone was updated';
                    } else {
                        $scope.status = 'Something went wrong';
                    }
                    $scope.alert = $timeout(function () {
                        $scope.status = undefined;
                    }, 10000);
                });
            },
        });

        angular.extend($scope, $flex.data);
    },
]);
